import styled from 'styled-components'

import { FormControlLabel } from '@components/ui/FormElements'

export const CustomFormControlLabel = styled(FormControlLabel).attrs({
  alignControl: 'flex-start',
  gap: 16,
})`
  margin: 8px 0;

  &[data-disabled='true'] > div:has(input[type='checkbox']) {
    opacity: 0.3;
  }
`
